export default __webpack_public_path__ + "static/media/BrandLogos.f7a9a7d4.svg";